import { AlertTriangle } from 'lucide-react';

interface WeatherConditionsWarningProps {
  message: string;
  className?: string;
}

/** Safety-relevant forecast note — amber warning icon, no semicolons. */
export function WeatherConditionsWarning({ message, className = '' }: WeatherConditionsWarningProps) {
  return (
    <div
      className={`flex gap-2 rounded-lg border border-amber-200/70 bg-amber-50/90 px-2.5 py-2 text-xs leading-relaxed text-amber-800 dark:border-amber-800/50 dark:bg-amber-950/35 dark:text-amber-200 ${className}`}
      role="note"
    >
      <AlertTriangle size={14} className="mt-0.5 shrink-0" aria-hidden />
      <span>{message}</span>
    </div>
  );
}
